import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, TicketViewModel, Pattern, TicketStatus } from '../../../../models';

class TicketAuditSearchBarController implements angular.IComponentController {
    filteredItems: TicketViewModel[];
    items: TicketViewModel[];
    searchCriteria: Pattern<TicketViewModel>[];
    ticketStatuses: TicketStatus[];

    static $inject = ['$translate'];
    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    $onInit() {
        this.searchCriteria = this.getSearchCriteria();
    }

    getSearchCriteria() {
        const searchCriteria: Pattern<TicketViewModel>[] = [
            {
                placeholder: 'Search pattern on ticket ID',
                label: 'Ticket ID',
                model: 'id',
                property: 'id',
                isMatch: (ticketViewmodel, reg, orig) => {
                    return ticketViewmodel.model.id === +orig;
                }
            },
            {
                placeholder: 'Search pattern on title',
                label: 'Title',
                model: 't',
                property: 't',
                isMatch: (ticketViewmodel, reg) => {
                    return reg.test(ticketViewmodel.model.title);
                }
            },
            {
                placeholder: 'Search pattern on user',
                label: 'User',
                model: 'u',
                property: 'u',
                isMatch: (ticketViewmodel, reg) => {
                    const isMatch =
                        reg.test(ticketViewmodel.assignedUser.displayName)
                        || reg.test(ticketViewmodel.closedUser.displayName)
                        || reg.test(ticketViewmodel.completedUser.displayName)
                        || reg.test(ticketViewmodel.creationUser.displayName)
                        || reg.test(ticketViewmodel.lastModifier.displayName);
                    return isMatch;
                }
            }, {
                placeholder: 'Search pattern on ticket category',
                label: 'Category',
                model: 'cat',
                property: 'cat',
                isMatch: (vm, reg) => vm.model.type && reg.test(vm.model.type?.name)
            }, {
                placeholder: 'Search on status (new, assigned, completed, rejected, closed)',
                label: 'Status',
                model: 's',
                property: 's',
                isMatch: (ticketViewmodel, reg, orig: string) => {
                    const status = _.find(this.ticketStatuses, s => s.id === ticketViewmodel.model.statusId);
                    const translated = this._$translate.instant(status.name);
                    const isMatch = reg.test(translated);
                    return isMatch;
                }
            }

        ];
        return searchCriteria;
    }
}

export const wtTicketAuditSearchBar: ComponentDefinition = {
    componentId: 'wtTicketAuditSearchBar',
    controller: TicketAuditSearchBarController,
    template: require('./ticketAuditSearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        items: '<',
        filteredItems: '=',
        ticketStatuses: '<'
    }
};
